import _ from 'underscore';
import { FilterEditor } from '@bingads-webui/filter-editor';
import { DeterministicWrapperView } from '@bingads-webui/deterministic-wrapper-view';
import { BaseFilterAgent } from './base-filter-agent';

class DeterministicFilterEditor extends DeterministicWrapperView {
  viewFactory(options) {
    return new FilterEditor(options);
  }
}

/**
 * Manage the creation/removal and show/hide of FilterEditor view<br>
 * Call FilterService to change filter state<br>
 * Set up a toolbar dropdown as filter menu<br>
 * @extends BaseFilterAgent
 * @fires FilterEditorAgent#filter-editor-shown
 */
export class FilterEditorAgent extends BaseFilterAgent {
  /**
   * Remove existing FilterEditor, create and show a new one
   * @param {Object} [filter] - FilterEntity
   * @param {string} [name] - Filter name
   * @returns {undefined}
   */
  create(filter) {
    let selected = filter;

    if (this.options.preprocessSelectedFilter) {
      selected = this.options.preprocessSelectedFilter(selected);
    }

    const view = new DeterministicFilterEditor({
      selected,
      shortDateFormat: this.options.shortDateFormat,
      entitySchema: this.options.entitySchema,
      schemaI18n: this.options.schemaI18n,
      ignoreCase: this.options.odata.ignoreCase,
      isComparingEnabled: _.isFunction(this.options.editor.isComparingEnabled) ?
        this.options.editor.isComparingEnabled() : this.options.editor.isComparingEnabled,
      hasInlineReporting: this.options.editor.hasInlineReporting,
      layoutTemplate: this.options.editor.layoutTemplate,
      itemTemplates: this.options.editor.itemTemplates,
      ko_model: this.options.editor.ko_model,
      i18n: this.options.i18n,
    });

    this.listenTo(view, 'apply', this.apply);
    this.listenTo(view, 'cancel', () => {
      this.trigger('cancel-edit');
    });

    return view;
    // TODO: during filter editor is show, also monitor dateFilter change for once.
    /*
    dateFilter.events.once('dateChange', () => {
      hideFilterEditor();
    });
    */
  }

  /**
   * Save filter to storage
   * @private
   * @param {string} query - Filter query
   * @param {string} name - Filter name
   * @returns {undefined}
   */
  apply(query, name) {
    if (name) {
      const { savedFilters } = this.options.filterService;
      if (_.isNumber(this.options.maxSavedFilterLimit)
      && savedFilters.length >= this.options.maxSavedFilterLimit) {
        const filterNames = _.pluck(savedFilters, 'name');
        if (!_.contains(filterNames, name)) {
          this.trigger('filter-max-reached');
          return;
        }
      }
      this.options.filterService.addUpdateSavedFilter(query, name).then((savedData) => {
        if (!savedData.error) {
          this.trigger('filter-saved-success');
        }
      });
    } else {
      super.apply(query, name);
    }
  }
}
